import {createStore} from 'vuex'
import userModule from "./modules/user";
import companyModule from "./modules/company";
import firmasModule from "./modules/firmas";
import contactModule from "./modules/contact";
import branchenModule from "@/store/modules/branchen";

export default createStore({
    strict: true,
    modules: {
        userModule,
        companyModule,
        firmasModule,
        branchenModule,
        contactModule
    }
})
